import React, { FC } from 'react';

import { Stepper as BaseStepper, type StepperProps as BaseStepperProps } from 'app/design-system/components/Stepper';
import { useTranslation } from 'app/lang';

import dictionary from './Stepper.dictionary.json';

// ---

type StepperProps = Omit<BaseStepperProps, 'stepsLabels'>;

const Stepper: FC<StepperProps> = (props) => {
  const { t } = useTranslation();

  const stepsLabels = {
    active: t(dictionary.active),
    visited: t(dictionary.visited),
    notVisited: t(dictionary.notVisited),
  };

  return (
    <BaseStepper {...props}
                 stepsLabels={stepsLabels} />
  );
};

export default Stepper;
